// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-pencil';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.576 12.96c0-2.808 2.304-5.04 5.04-5.04.648 0 1.368.144 2.016.432M2.52 3.672c0 1.728 1.368 3.096 3.096 3.096S8.712 5.4 8.712 3.672 7.344.576 5.616.576 2.52 1.944 2.52 3.672zm14.472 7.488-5.688 5.688-2.808.576.576-2.808 5.688-5.688c.288-.288.72-.432 1.152-.432s.792.144 1.152.432c.288.288.432.72.432 1.152-.072.36-.216.792-.504 1.08z'
  />
);

export const viewBox = '0 0 18 18';
